<template id="youtube-player">
    <div>
        <div class="aspect-16x9">
            <iframe
                    width="560"
                    height="315"
                    v-bind:src="video"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen>

            </iframe>
        </div>
    </div>

</template>

<script>

    import TheTextView from './TheTextView'

    export default {
        name: 'TheYouTube',
        components: {
            TheTextView
        },
        data() {
            return {
            }
        },

        props: {
            video: ''
        },
        created: function() {

        }
    }
</script>

<style lang="scss">
    .aspect-16x9 {
        position: relative;
        height: 0;
        padding-bottom: 75%;
        margin-bottom: 1rem;
        overflow: hidden;
        iframe{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }
    .borderelement{
        &:before,
        &:after{
            content: '';
            width: 8px;
            height: 40px;
            position: absolute;
        }
        &:before{
            background-color: #c93c26;
            left: 0;
            top: 0;
        }
        &:after{
            background-color: #47ab4c;
            right: 0px;
            bottom: 0;
        }
    }
</style>
